var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud-Upload--Streamline-Ultimate.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.7377 52.4304H61.4052C61.4052 52.4304 75.1428 50.6381 75.1428 37.1497C75.1443 35.0973 74.7315 33.0658 73.9291 31.1768C73.1267 29.2877 71.9512 27.5802 70.473 26.1563C68.9949 24.7325 67.2445 23.6217 65.3268 22.8905C63.4091 22.1593 61.3635 21.8227 59.3126 21.901C57.2894 17.6068 53.8932 14.109 49.6605 11.9601C45.4278 9.81124 40.5998 9.13376 35.9391 10.0347C31.2784 10.9356 27.0507 13.3636 23.9237 16.9351C20.7968 20.5066 18.9488 25.0181 18.6717 29.757C17.0045 29.4063 15.28 29.432 13.624 29.832C11.9679 30.232 10.4219 30.9964 9.09853 32.0694C7.77518 33.1424 6.7078 34.497 5.97413 36.0347C5.24046 37.5723 4.85896 39.2542 4.85742 40.9579C4.85742 52.6029 17.0807 52.4208 17.0807 52.4208H26.2274",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40 34.8594V70.0021",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.5843 44.4437L39.9999 34.8594L30.4155 44.4437",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.6c22d157518d6ff9f1c60d6101dae4e2.svg";
export { ForwardRef as ReactComponent };